//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').directive('datatableList', () => ({
    restrict: 'E',
    scope: {},
    require: '^datatable',
    compile(element) {
      const template = element.find('datatable-list-item');
      const wrapper = angular.element('<div></div>');
      const datatable = angular.element('<div class="angular-datatable list datatables-next no-padding col-xs-12"></div>');
      const header = angular.element('<div class="list-header"></div>');
      const gridContainer = angular.element('<div class="list-item-container pull-left"></div>').attr('ng-repeat', 'context in model.items');
      const directionContainer = angular.element('<div class="col-xs-3 pull-right text-right no-padding"></div>');
      const directionButton = angular.element('<button class="btn btn-prim-inverse sortable"></button>');
      const clearfix = angular.element('<div class="clearfix"></div>');

      gridContainer.append(template.html());

                // Direction Button
      directionButton.attr('ng-class', '{"sort-asc": model.sorting.direction === "asc", "sort-desc": model.sorting.direction === "desc" }');
      directionButton.attr('ng-bind', 'model.sorting.direction === "asc"  ? "Ascending" : "Descending"');
      directionButton.attr('ng-click', 'model.changeSortDirection()');
      directionButton.attr('ng-disabled', 'model.loading');

      directionContainer.append(directionButton);

      wrapper.append(datatable);
      datatable.append(header);
      datatable.append(gridContainer);
      datatable.append(clearfix.clone());
      datatable.after(clearfix.clone());

      return {
        pre: null,
        post(scope, elem, attrs, table) {
          table.registerView('list', wrapper);
        },
      };
    },
  }));
})();
